import { render, staticRenderFns } from "./AnalyseChat.vue?vue&type=template&id=3c6cd38b&scoped=true"
import script from "./AnalyseChat.vue?vue&type=script&lang=js"
export * from "./AnalyseChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6cd38b",
  null
  
)

export default component.exports